import { useMemo } from 'react';
import { Nullable } from 'types';
import { Song } from 'services/store/songs/types';
import { SongType } from 'services/api/entities';

export interface UseGetSongGenre {
  genre: string;
}
const useGetSongGenre = (song: Nullable<Song>): UseGetSongGenre => {
  const genre = useMemo(() => {
    if (!song) {
      return '';
    }

    const { songType } = song;
    if (songType === SongType.FREE || songType === SongType.CUSTOMIZABLE) {
      // @ts-ignore
      return song.genres?.[0]?.name ?? '';
    }
    return '';
  }, [song]);

  return {
    genre,
  };
};

export default useGetSongGenre;
